module.exports = __webpack_public_path__ + "icon.718f87fb.svg";